<script setup lang="ts">
import { useGameStore } from "@/stores/games.ts";
import GameTableItem from "@/components/game/GameTableItem.vue";
import { computed } from "vue";

const gameStore = useGameStore();

const props = defineProps<{
  filterTeamId?: string;
}>();

const filteredGames = computed(() => {
  return gameStore.games.filter(game => {
    if (props.filterTeamId) {
      return game.teams.home.id === props.filterTeamId || game.teams.away.id === props.filterTeamId;
    }
    return true;
  });
});

</script>

<template>
  <div class="list">
    <template
      v-for="(game, index) in filteredGames"
      :key="game.id"
    >
      <div
        class="day"
        v-if="index === 0 || new Date(game.dateTime).toDateString() !== new Date(filteredGames[index - 1].dateTime).toDateString()"
      >
        {{ new Date(game.dateTime).toLocaleDateString('de-DE', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        }) }}
      </div>
      <GameTableItem
        :game="game"
      />
    </template>
    <div class="hint">
      Angaben ohne Gewähr. Fehler vorbehalten.
    </div>
  </div>
</template>

<style scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.day {
  text-align: center;
}

.hint {
  text-align: center;
  color: var(--text-color-layer-1);
  font-size: 0.8rem;
}
</style>
